export enum NotificationDeliveryMethod {
  ViaEmail = 1,
  ViaInSystem = 2,
  ViaDashboard = 3,
}